export const ICONS_NAME = {
    // Sidebar
    logo: 'logo',
    home: 'home',
    categories: 'categories',
    users: 'users',
    logout: 'logout',
    sidebarImages: 'sidebarImages',
    sidebarStores: 'sidebarStores',
    sidebarPegs: 'sidebarPegs',
    sidebarProjects: 'sidebarProjects',

    // Team
    password: 'password',
    reactivate: 'reactivate',
    revoke: 'revoke',
    info: 'info',
    modify: 'modify',
    comment: 'comment',

    // Pagination
    paginationRight: 'paginationRight',
    chevronLeft: 'chevronLeft',
    chevronRight: 'chevronRight',

    // Search
    search: 'search',
    cart: 'cart',

    // Categories
    alert: 'alert',
    items: 'items',
    stores: 'stores',
    edit: 'edit',

    // Tabs
    detailed: 'detailed',
    history: 'history',
    settings: 'settings',
    shelf: 'shelf',
    summary: 'summary',
    table: 'table',
    tree: 'tree',
    unranged: 'unranged',
    editNote: 'editNote',

    // Select
    clear: 'clear',
    expand: 'expand',
    collapse: 'collapse',
    loader: 'loader',
    filter: 'filter',

    // POG settings
    bay: 'bay',
    flip: 'flip',
    image: 'image',
    legend: 'legend',
    zoomOut: 'zoomOut',
    zoomIn: 'zoomIn',
    sadRobot: 'sadRobot',

    // Checkboxes
    checkboxOn: 'checkboxOn',
    checkboxOff: 'checkboxOff',
    check: 'check',

    // Modal
    close: 'close',
    maximize: 'maximize',
    shrink: 'shrink',
    modalAlert: 'modalAlert',
    modalPlanogram: 'modalPlanogram',

    // Range
    rangeHandle: 'rangeHandle',
    rangeHandleHover: 'rangeHandleHover',

    // Inputs
    user: 'user',
    email: 'email',
    eyeOn: 'eyeOn',
    eyeOff: 'eyeOff',
    phone: 'phone',
    google: 'google',
    delete: 'delete',
    add: 'add',
    tooltip: 'tooltip',

    // Arrows
    arrowLeft: 'arrowLeft',
    arrowRight: 'arrowRight',
    downArrow: 'downArrow',

    // Files
    csvError: 'csvError',
    csvGrey: 'csvGrey',
    csvGreen: 'csvGreen',
    downLoad: 'downLoad',

    // Other
    roundMinus: 'roundMinus',
    roundPlus: 'roundPlus',
    expandDown: 'expandDown',
    expandUp: 'expandUp',
    drag: 'drag',
    collapse2: 'collapse2',
    increase: 'increase',
    emptyData: 'emptyData',
    photo: 'photo',

    // Menu
    dot: 'dot',

    // require rebuild
    infoSolid: 'infoSolid',
    calendar: 'calendar',
    refresh: 'refresh',
}